import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

/** Канонический порядок значений `?source=` — фиксированный, для стабильного кэша. */
const SOURCES: ChatAnalyze.AnalysisSource[] = ["manual", "guest-bot"]

const LABELS: Record<ChatAnalyze.AnalysisSource, string> = {
  manual: "Ручные",
  "guest-bot": "Гостевые боты",
}

function parseSourceCsv(
  source: string | undefined,
): ChatAnalyze.AnalysisSource[] {
  if (!source) return []
  const selected = new Set(source.split(",").map((s) => s.trim()))
  return SOURCES.filter((s) => selected.has(s))
}

/** serialize(["manual", "guest-bot"]) → "manual,guest-bot"; пустой выбор → undefined. */
function serialize(values: ChatAnalyze.AnalysisSource[]): string | undefined {
  const ordered = SOURCES.filter((s) => values.includes(s))
  return ordered.length > 0 ? ordered.join(",") : undefined
}

interface SourceFilterChipsProps {
  /** CSV `?source=` или undefined (= без фильтра). */
  source: string | undefined
  onChange: (source: string | undefined) => void
}

export function SourceFilterChips({
  source,
  onChange,
}: SourceFilterChipsProps) {
  const handleChange = (
    _e: React.MouseEvent<HTMLElement>,
    value: ChatAnalyze.AnalysisSource[],
  ) => onChange(serialize(value))

  return (
    <ToggleButtonGroup
      size="small"
      value={parseSourceCsv(source)}
      onChange={handleChange}
      aria-label="Источник анализа"
    >
      {SOURCES.map((s) => (
        <ToggleButton key={s} value={s}>
          {LABELS[s]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
